<template>
  <div>
    <div class="modal" id="mydetailsOCRModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-head mt-4 mx-4 d-flex ocr-link pb-1 justify-content-between">
            <h4 class="modal-title mb-2">Enter Details for OCR Link</h4>
            <button type="button" class="close position-relative ml-2" data-dismiss="modal" id="mydetails-ocr-cross-close">&times;</button>
          </div>
          <!-- Modal body -->
          <div class="modal-body px-4 pb-2">
            <div class="ocr-link">
              <div class="form-group mt-5">
                <float-label>
                  <input type="text" class="form-control" placeholder="Email-ID" maxlength="80">
                </float-label>
              </div>

              <div class="form-group mb-4">
                <float-label>
                  <input type="text" class="form-control" placeholder="Mobile Number">
                </float-label>
              </div>
            </div>
          </div>
          <div>
            <div class="modal-footer border-0">
              <div class="float-left mr-4" v-if="ocrPinLink">
                <p>
                  OCR PIN link has been
                  <br>successfully sent
                  <strong>OCR PIN: 2020-00001234</strong>
                </p>
              </div>
              <div class="float-right">
                <button
                  type="button"
                  class="btn bgc-btn-primary button-add"
                  data-toggle="collapse"
                  aria-label="Expand Journey Details"
                  @click="sendlink"
                  :class="{ 'down': ocrPinLink }"
                  id="mydetails-send-link"
                >Send Link</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
export default {
  name: "MydetailsOCRModal",
  components: {
    FloatLabel
  },
  data() {
    return {
      ocrPinLink: false,
    };
  },
  methods: {
    sendlink: function() {
      this.ocrPinLink = !this.ocrPinLink;
    }
  }
};
</script>

<style scoped>
.ocr-link {
  border-bottom: 1px solid #c7c7c7;
}
.close {
  left: 10px;
}
.button-add {
  width: 130px;
}
.button-add.down {
  opacity: 0.65;
  pointer-events: none;
  cursor: not-allowed;
}
input[type="text"] {
  max-width: 449px;
}
</style>
